import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { LogService } from '../core/service/log.service';
import { ConfirmDialogComponent } from '../shared/confirmDialog.component';
import { VRApplication } from './model/VRApplication';
import { PreregApplicationService } from './service/prereg.service';

@Component({
    selector: 'app-voluntary-removal-application',
    templateUrl: './voluntaryRemovalApplication.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VoluntaryRemovalComponent implements OnInit, OnDestroy {

  @Input()application!: VRApplication;
  name!: string;
  stepTitle!: string;
  isUserSI = false;
  voluntaryRemovalDetails: NonNullable<VRApplication['form']>['voluntaryRemovalDetails'] | null = null;
  appDeclaration: any = null;
  FtPAnswers: Record<string, number | undefined> = {};
  FtPSubAnswers: Record<string, number | undefined> = {};
  index = 0;
  @Input() event!: Observable<string>;
  @Output() applicationDeleted = new EventEmitter<boolean>();

  private eventSubscription!: Subscription;

  constructor(private dialog: MatDialog,
    private log: LogService,
    private preregService: PreregApplicationService) { }

  ngOnInit(): void {

    this.eventSubscription = this.event.subscribe(( userID) => this.deleteApplication(userID));

    this.name = this.application?.applicantDetails ? (this.application.applicantDetails.forenames + ' ' + this.application.applicantDetails.surname) :
                    '';
    this.voluntaryRemovalDetails = this.application?.form?.voluntaryRemovalDetails ? this.application.form.voluntaryRemovalDetails : null;    
    this.appDeclaration = this.application?.form?.appDeclaration ? this.application.form.appDeclaration : null;
    this.stepTitle = this.isUserSI ? 'Date removal required, Superintendent (SI) & Reason for removal': 
                        'Date removal required & Reason for removal';
    if (this.application.ftpQuestions) {

      for (const question of this.application.ftpQuestions) {
        const answerKey = question.answer;

        if (answerKey == null) {
          continue;
        }

        if (question.body !== null) {
          this.FtPAnswers[answerKey] = (this.FtPAnswers[answerKey] ?? 0) + 1;
        } else {
          this.FtPSubAnswers[answerKey] = (this.FtPSubAnswers[answerKey] ?? 0) + 1;
        }
      }

    }
  }

  getObjectLength(obj: object): number {
    return Object.keys(obj).length;
  }

  deleteApplication(userId: string) {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: `Delete confirmation`,
        message: `Are you sure you want to delete the partially filled VR application?`,
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        const message = 'VR application belonging to applicant with registration number ' + userId + ' is deleted successfully';
        this.preregService.deleteVRApplication(userId).subscribe(data => {
          this.applicationDeleted.emit(true);
          this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
              allowCancel: false,
              confirmText: `ok`,
              title: `Application deleted`,
              message: message,
            }
          });
        }, error => {
          this.applicationDeleted.emit(false);
          this.log.error('deleting VR application failed', error);
        });
      }
    });
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }
}